import api from '@/services/api/api';

export const useArticleBySlug = (slug) => {
  const articleSlug = useQuery(
    ['articleSlug', slug],
    async () => {
      const { data } = await api.articles.getArticleBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await articleSlug.suspense();
  });

  return {
    articleSlug,
  };
};
